import { useState } from 'react';
import { Form as FormB } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { postRequisitosGenerales } from '../../../../appStore/convocatoria';
import { useConcurso } from '../../../../providers/ConcursoProvider';
import Form from '../../../CompUtils/Form';

const Root = styled.div`
  margin-top: 2rem;
`;

export const RequisitosGeneral = () => {
  const dispatch = useDispatch();
  const concurso = useConcurso();
  const { requisitoLlamadoConcurso, idLlamadoConcurso } = concurso;

  const [requisito, setRequisitoLlamadoConcurso] = useState(
    requisitoLlamadoConcurso ? requisitoLlamadoConcurso.descripcion : '',
  );

  return (
    <Root>
      <Form
        onSubmit={() => {
          dispatch(
            postRequisitosGenerales({ idLlamadoConcurso, requisitoLlamadoConcurso: requisito }),
          );
        }}
        submitText="Guardar requisitos"
        btns={['submit']}>
        <FormB.Control
          as="textarea"
          title="Requisitos de la convocatoria"
          id="requisitoLlamadoConcurso"
          value={requisito}
          onChange={(e: any) => {
            setRequisitoLlamadoConcurso(e.target.value);
          }}
        />
      </Form>
    </Root>
  );
};
